import get from 'lodash.get';
import { domainMetaData } from '../../views/UserMessaging/userMessageDomains';

import { errorMessages as campaignErrorMessages } from '../../views/Campaign';
import { errorMessages as templateErrorMessages } from '../../views/Template';
import { errorMessages as attachmentTemplateErrorMessages } from '../../views/AttachmentTemplates';
import { errorMessages as recipientQueryErrorMessages } from '../../views/RecipientQueries';
import { errorMessages as settingsErrorMessages } from '../../views/Settings';
import { errorMessages as conditionQueryErrorMessages } from '../../views/ConditionQueries';

let errorMessageContextsByFailedActions = {
  ...campaignErrorMessages,
  ...templateErrorMessages,
  ...attachmentTemplateErrorMessages,
  ...recipientQueryErrorMessages,
  ...settingsErrorMessages,
  ...conditionQueryErrorMessages
};

export default (failedAction, userMessageDomain) => {
  let backUpContext = {
    resource: get(domainMetaData, [userMessageDomain, 'resource'])
  };

  return get(
    errorMessageContextsByFailedActions,
    [userMessageDomain, failedAction.type],
    backUpContext
  );
};
